// extracted by mini-css-extract-plugin
module.exports = {"actionsGroup":"permissionActions_actionsGroup__3AZe1","action":"permissionActions_action__2dGiX"};